export default __webpack_public_path__ + "static/media/default.59a831b5af6ba2633fefb9becad826dc.png";